@if (person() && formGroup()) {
    <section class="flex flex-col gap-10">
        @if (canEditPerson()) {
            <div
                class="flex flex-col gap-10"
                [class.opacity-50]="!hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_PERSON])"
                [class.pointer-events-none]="
                    !hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_PERSON])
                ">
                <app-input-text
                    data-testid="user-name-input"
                    [inputFormControl]="formGroup()!.controls.name"
                    [label]="'name' | transloco"
                    [placeholder]="person()!.familyName" />
                <app-input-text
                    data-testid="user-given-name-input"
                    [inputFormControl]="formGroup()!.controls.firstName"
                    [label]="'givenName' | transloco"
                    [placeholder]="person()!.givenName" />
                <app-input-text
                    data-testid="user-email-input"
                    [errors]="mailIsValid(formGroup()!, mailError()) ? [mailIsValid(formGroup()!, mailError())!] : []"
                    [inputFormControl]="formGroup()!.controls.mail"
                    [label]="'email' | transloco"
                    [placeholder]="person()!.email" />

                <div class="flex flex-col gap-0.5">
                    <label class="font-normal text-base">{{ 'license' | transloco }}</label>

                    <app-licenses-select
                        [currentUserLicenses]="licensesSelected()"
                        (onLicensesChange)="onLicensesChange($event)" />
                </div>

                <app-select
                    placeholder="selectRole"
                    [class.opacity-50]="!connectServicesLicense()"
                    [class.pointer-events-none]="!connectServicesLicense()"
                    [defaultValue]="rolesSelected()"
                    [label]="'role' | transloco: { COUNT: 1 }"
                    [options]="roles()"
                    (optionSelected)="onSelectedRoleChange($event)" />

                <div class="flex flex-col gap-0.5">
                    <app-input-number
                        [disabled]="streetViewQuotaDisabled()"
                        [inputFormControl]="formGroup()!.controls.streetViewQuota"
                        [label]="'streetView.requestQuota' | transloco"
                        [matTooltip]="streetViewQuotaTooltip() | transloco"
                        [max]="allocatableQuota() ?? 0"
                        [min]="0"
                        [placeholder]="streetViewQuotaDisabled() ? '' : undefined" />
                    @if (allocatableQuota() !== null) {
                        <span>
                            {{ 'streetView.grantedRequest' | transloco: { count: allocatableQuota() } }}
                        </span>

                        @if (securityService.meSignal()!.organization.streetViewQuotaRemaining) {
                            <span class="pt-2">
                                {{
                                    'streetView.remainingRequest'
                                        | transloco
                                            : {
                                                  count: securityService.meSignal()!.organization
                                                      .streetViewQuotaRemaining,
                                              }
                                }}
                            </span>
                        }
                    }
                </div>
            </div>
        }

        @if (canEditUserProjects()) {
            <app-select
                [defaultValue]="projectsSelected()"
                [isMultiSelect]="true"
                [label]="`${('project' | transloco: { COUNT: 1 })}(s)`"
                [options]="projects()"
                [placeholder]="'selectProjects' | transloco: { COUNT: projects().length }"
                (optionSelected)="onSelectedProjectsChange($event)" />
        }
    </section>
}
